import { Competition, CompetitionStatus, Judge, User, UserCompetition } from '@vote4dance/judging-schema';
import { CompetitionId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export enum CompetitionStatusFilter {
    Active = 'active',
    Current = 'current',
    Upcoming = 'upcoming',
    Archive = 'archive'
}

export enum EventRangeFilter {
    Active = 'active',
    Future = 'future',
    Past = 'past',
    User = 'user'
}

export enum CompetitionLevel {
    Practice = 0,
    Standard = 1,
    GrandSlam = 2,
    NationalChampionship = 3
}

export type CompetitionItem = Competition
& Pick<User, 'user_firstname' | 'user_lastname'>
& Pick<UserCompetition, 'usercompetition_level'>
& Pick<Judge, 'judge_id'>
& {
    competition_num_floors: number,
    competition_is_checkin_open: number,
    competition_events: number,
    competition_federation: string,
    judge_pin_created: number
}

type CompetitionItemCompanion = {
    hasMultipleFloors(competition: CompetitionItem): boolean;
    shouldHideMarks(competition: CompetitionItem): boolean;
}

export const CompetitionItem: CompetitionItemCompanion = {
    hasMultipleFloors(competition: CompetitionItem): boolean {
        return competition.competition_num_floors > 1
    },
    shouldHideMarks(competition: CompetitionItem): boolean {
        if (competition.competition_publish_results != 1) {
            if (competition.competition_publish_results == 0) {
                return true;
            }
            return [CompetitionStatus.Private, CompetitionStatus.Public].includes(competition.competition_status);
        }
        return false;
    }
}

export interface CompetitionPage {
    offset: number, 
    count: number, 
    pageSize: number, 
    competitions: [CompetitionItem]
}

export function EventPageSource(range: EventRangeFilter, offset: number,size: number) {
    return new StreamSource<CompetitionPage>(`/event-page/${range}/${offset}/${size}`);
}

export function CompetitionsPageSource(filter: CompetitionStatusFilter, size: number) {
    return new StreamSource<CompetitionPage>(`/competition-page/${filter}/0/${size}`);
}

export function ActiveCompetitionSource(competition_id: CompetitionId) {
    return new StreamSource<CompetitionItem[]>(`/active-competition/${competition_id}`);
}

export function CompetitionValidationSource(competition_id: CompetitionId) {
    return new StreamSource<any[]>(`/competition-validation/${competition_id}`);
}

export function EventSource(competition_id: CompetitionId) {
    return new StreamSource<CompetitionItem[]>(`/events/${competition_id}`);
}


export const CompetitionsSource = new StreamSource<CompetitionItem[]>("/competitions");
export const AdminCompetitionsSource = new StreamSource<CompetitionItem[]>("/admin-competitions");
